<div class="matching-widget">
  @if (questions?.length) {
    <lib-question-hint
      [hint]="'SLIDES.pair_cards_by_clicking_on_matching' | translate">
    </lib-question-hint>
  }

  <div
    class="matching-question"
    [@.disabled]="disableAnimations">
    <div class="matching-options-list" cdkDropList (cdkDropListDropped)="onDrop($event)">

      @for (item of questions; track trackByFn(i, item); let i = $index) {
        <lib-question-option
          @itemAnimation
          class="animate__animated"
          cdkDrag
          [class.error]="showError && !item.text"
          [cdkDragDisabled]="!canEdit"
          [canEdit]="canEdit"
          [isTranslation]="isTranslation"
          [ngClass]="animation"
          [style.animationDelay.ms]="animationDelay + i * 200"
          [index]="item.index"
          [text]="item.text"
          [active]="item === activeOption"
          (click)="markOptionAsActive(item)"
          (edit)="edit.emit(i)"
          (remove)="remove.emit(i)">
        </lib-question-option>
      }
    </div>

    <div class="matching-options-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
      @for (item of answers; track trackByFn(i, item); let i = $index) {
        <lib-question-option
          @itemAnimation
          class="animate__animated"
          cdkDrag
          [class.error]="showError && !item.text"
          [cdkDragDisabled]="!canEdit"
          [canEdit]="canEdit"
          [isTranslation]="isTranslation"
          [ngClass]="animation"
          [style.animationDelay.ms]="animationDelay + i * 200"
          [index]="item.index"
          [numeric]="true"
          [text]="item.text"
          [active]="item === activeAnswer"
          (click)="markAnswerAsActive(item)"
          (edit)="edit.emit(i)"
          (remove)="remove.emit(i)">
        </lib-question-option>
      }
    </div>

  </div>

  @if (output?.length) {
    <div class="matched-options">
      <h6 class="matched-options-label">
        {{ 'SLIDES.matching_pairs' | translate }}
      </h6>
      @for (pair of output; track pair; let index = $index) {
        <div class="matched-pair" @matchAnimation>
          <lib-question-option class="matching-option" [index]="pair.question.index" [text]="pair.question.text"></lib-question-option>
          <div class="matching-line">
            <hr class="line">
            <button
              mat-icon-button
              [matTooltip]="'SLIDES.detach_pair' | translate"
              matTooltipClass="dark-tooltip"
              (click)="detachMatching(index)"
              aria-label="Detach"
              class="button button--icon button--icon-extra-small button--primary detach-icon">
              <lib-icon icon="link-break"></lib-icon>
            </button>
          </div>
          <lib-question-option class="matching-option" [index]="pair.question.index" [numeric]="true" [text]="pair.answer.text"></lib-question-option>
        </div>
      }
    </div>
  }
</div>
